import React from "react";
import * as SCM from "../../style/StyleComponentMenu";
import ChiefManager from "./ChiefManager";


const Instructor: React.FC = () => {

  return (
    <>
      <SCM.MenuContainer>
        <ChiefManager />
      </SCM.MenuContainer>
    </>
  )
};

export default Instructor;